"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueForCurrentScreenSize = exports.getValueByScreenSize = exports.createStylesForBreakpoints = exports.compareBreakpoints = exports.isBreakpointConfig = exports.Breakpoints = void 0;
/**
 * Layout changes should only happen on the design breakpoints (560, 960, 1600).
 * The others (1280, 1920) should only be used to help with responsive design
 * within the viewport (960 to 1600 or 1600 to 2560) and not be used to create
 * fundamentally different designs.
 */
var Breakpoints;
(function (Breakpoints) {
    Breakpoints[Breakpoints["default"] = 0] = "default";
    Breakpoints[Breakpoints["b560"] = 560] = "b560";
    Breakpoints[Breakpoints["b960"] = 960] = "b960";
    Breakpoints[Breakpoints["b1280"] = 1280] = "b1280";
    Breakpoints[Breakpoints["b1600"] = 1600] = "b1600";
    Breakpoints[Breakpoints["b1920"] = 1920] = "b1920";
    Breakpoints[Breakpoints["b2560"] = 2560] = "b2560";
    Breakpoints[Breakpoints["never"] = Infinity] = "never";
})(Breakpoints || (exports.Breakpoints = Breakpoints = {}));
const breakpoints = Object.values(Breakpoints);
function isBreakpointConfig(prop) {
    return (typeof prop === 'object' &&
        Object.keys(prop).every((key) => breakpoints.includes(key) || breakpoints.includes(parseInt(key, 10))));
}
exports.isBreakpointConfig = isBreakpointConfig;
/**
 * Compare two breakpoints to each other
 *
 * Pass to sort the breakpoints in ascending order
 *
 * All non-default breakpoints can also be passed as strings to enable mapping over Objects with breakpoints as keys:
 * ```
 * const breakpointConfig = {
 *     [Breakpoints.default]: theme.size.static250,
 *     [Breakpoints.b560]: theme.size.static350
 * };
 *
 * Object.keys(breakpointConfig).sort(compareBreakpoints).map(breakpoint => `
 *     @media (min-with: ${breakpoint}) {
 *         padding: ${breakpointConfig[breakpoint]}
 *     }
 * `)
 * ```
 */
function compareBreakpoints(a, b) {
    return ((typeof a === 'number' ? a : parseInt(a, 10)) -
        (typeof b === 'number' ? b : parseInt(b, 10)));
}
exports.compareBreakpoints = compareBreakpoints;
function mediaQueryTemplate(breakpoint, styles) {
    if (breakpoint === '0') {
        return styles;
    }
    return `@media (min-width: ${breakpoint}px) {${styles}}`;
}
function createStylesForBreakpoints(config, fn = (x) => x) {
    if (!isBreakpointConfig(config)) {
        return fn(config);
    }
    return Object.keys(config)
        .sort(compareBreakpoints)
        .map((breakpoint) => mediaQueryTemplate(breakpoint, fn(config[breakpoint])))
        .join('');
}
exports.createStylesForBreakpoints = createStylesForBreakpoints;
function getValueByScreenSize(screenSize, config) {
    if (!isBreakpointConfig(config)) {
        return config;
    }
    const activeBreakpoint = Object.keys(config)
        .sort(compareBreakpoints)
        .reduce((acc, key) => {
        const breakpoint = typeof key === 'number' ? key : parseInt(key, 10);
        return screenSize >= breakpoint ? key : acc;
    }, '');
    return config[activeBreakpoint];
}
exports.getValueByScreenSize = getValueByScreenSize;
function getValueForCurrentScreenSize(config) {
    const width = typeof window !== 'undefined' ? window.innerWidth || 0 : 0;
    return getValueByScreenSize(width, config);
}
exports.getValueForCurrentScreenSize = getValueForCurrentScreenSize;
